module.exports = __webpack_public_path__ + "img/二维码.62260ac3.jpg";